/**
 * 奖励规则创建与编辑
 */
import React from 'react';
import {
    Form,
    Input,
    InputNumber,
    Radio,
    Row,
    Col,
    DatePicker,
    Space,
} from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './Reward.module.scss';
import model from '@/reducers/system/operatingrule/model';
import { regFenToYuan } from '@/util/money';
import moment from 'moment';


const FormItem = Form.Item;
const { RangePicker } = DatePicker;
const RadioGroup = Radio.Group;


//限制时间范围
const range = (start, end) => {
    const result = [];
    for (let i = start; i < end; i++) {
        result.push(i);
    }
    return result;
};


class Reward extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isInit: true,
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.isInit) {
            if (Object.keys(nextProps.details).length > 0) {
                prevState.isInit = false;
                const {
                    type = {},
                    name,
                    gmtStart,
                    gmtEnd,
                    rewardValue,
                    serviceNum,
                    lvNum,
                    triggerType,
                    triggerConditionResp: {
                        userPraiseNum,
                        merchantPraiseNum,
                        deliveryAmount,
                        freeOrderNum,
                    } = {},
                } = nextProps.details;

                if (type.code == 'REWARD') {
                    return {
                        name: name,//名称
                        dataMoment: [moment(gmtStart == '' ? undefined : gmtStart), moment(gmtEnd == '' ? undefined : gmtEnd)],//起止日期
                        rewardValue: Number(regFenToYuan(rewardValue)),//现金
                        serviceNum: serviceNum,//服务分
                        lvNum: lvNum,//等级分
                        triggerType: triggerType,//触发条件
                        type: type.code,//类型(奖励/惩罚) 

                        userPraiseNum: userPraiseNum == '' ? undefined : userPraiseNum,
                        merchantPraiseNum: merchantPraiseNum == '' ? undefined : merchantPraiseNum,
                        deliveryAmount: deliveryAmount == '' ? undefined : (deliveryAmount ? Number(regFenToYuan(deliveryAmount)) : undefined),
                        freeOrderNum: freeOrderNum == '' ? undefined : freeOrderNum,

                    };
                } else {
                    return null;
                }
            }
        }
        return null;
    }

    //起止时间 
    disabledDate = (current) => {
        return current && current < moment().startOf('day');
    };
    disabledTime = (current, type) => {
        if (current && current.length === 2) {
            let disabled = {};
            if (type === 'start') {
                let limitTime = moment().startOf('seconds');
                disabled = {
                    disabledHours: () => range(0, 24).splice(0, limitTime.hours()),
                    disabledMinutes: () => range(0, 60).splice(0, limitTime.minutes()),
                    disabledSeconds: () => range(0, 60).splice(0, limitTime.seconds())
                };
                return disabled;
            }
        }
    }
    setDefaultStartTime = (times, initial) => {
        const { form } = this.props;
        if (Array.isArray(times) && times.length === 2) {
            if (moment(times[0]).valueOf() === moment(times[1]).valueOf()) {
                let initialTime = moment(times[1].format('YYYY-MM-DD HH:mm:ss')).add(1, 'seconds');
                times[1] = initialTime;
                form.setFieldsValue({
                    [initial]: times,
                });
            }
        }
    }


    render() {

        const { data, } = this.props;

        return (
            <div className={styles.container}>
                <div className={styles.colonTitle}>奖励内容</div>
                <Row style={{ marginBottom: 24 }}>
                    <Col offset={2} span={22}>
                        <FormItem
                            name="rewardReasons"
                            label="奖励名称"
                            colon={false}
                            rules={[
                                { required: true, min: 1, max: 256, whitespace: true },
                            ]}
                        >
                            <Input
                                style={{ width: 213 }}
                                placeholder="请输入"
                                maxLength={256}
                            />
                        </FormItem>
                    </Col>
                </Row>
                <Row style={{ marginBottom: 24 }}>
                    <Col offset={2} span={22}>
                        <FormItem
                            name="rewardDate"
                            label="起止日期"
                            colon={false}
                            rules={[
                                { required: true, type: 'array', },
                            ]}
                        >
                            <RangePicker
                                disabledDate={this.disabledDate}
                                disabledTime={this.disabledTime}
                                getCalendarContainer={trigger => trigger.parentElement}
                                onChange={dates => this.setDefaultStartTime(dates, 'rewardDate')}
                                showTime
                                format="YYYY-MM-DD HH:mm:ss"
                            />
                        </FormItem>
                    </Col>
                </Row>
                <div className={styles.colonTitle}>奖励方式</div>
                <Row style={{ marginBottom: 24 }}>
                    <Col offset={2} span={22}>
                        <FormItem className={`${styles.flexCurt}`}>
                            <FormItem
                                name="rewardFine"
                                label="奖励现金"
                                colon={false}
                                rules={[{ required: true, type: 'number', min: 0, max: 999.99, }]}>
                                <InputNumber
                                    style={{ width: 150, marginRight: '7px' }}
                                    keyboard={true}
                                    placeholder='请输入(元)'
                                    precision={2}
                                />
                            </FormItem>
                            <span className={styles.curtNote}>元<b>最大值999.99</b></span>
                        </FormItem>
                    </Col>
                </Row>
                <Row style={{ marginBottom: 24 }}>
                    <Col offset={2} span={22}>
                        <FormItem className={`${styles.flexCurt}`}>
                            <FormItem
                                name="rewardLevelScore"
                                label="奖等级分"
                                colon={false}
                                rules={[{ required: true, type: 'number', min: 0, max: 99, }]}>
                                <InputNumber
                                    style={{ width: 150, marginRight: '7px' }}
                                    keyboard={true}
                                    placeholder='请输入(分)'
                                    precision={0}
                                />
                            </FormItem>
                            <span className={styles.curtNote}>分<b>最大值99</b></span>
                        </FormItem>
                    </Col>
                </Row>
                <div className={styles.colonTitle}>触发条件</div>
                <Row>
                    <Col offset={2} span={18}>
                        <FormItem
                            name="rewardComprehensive"
                            colon={false}
                            //  initialValue={data ? (this.state.triggerType ? this.state.triggerType : 'COMPOSITE') : 'COMPOSITE'}
                            initialValue={'RANDOM'}
                            rules={[
                                { required: true, message: '请选择' },
                            ]}
                        >
                            <RadioGroup onChange={this.cardTypeHandle}>
                                <Space size={30}>
                                    <Radio value={'COMPOSITE'}>综合</Radio>
                                    <Radio value={'RANDOM'}>随机</Radio>
                                </Space>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col offset={2} span={22}>
                        <FormItem
                            noStyle
                            shouldUpdate={(prevValues, currentValues) => prevValues.rewardComprehensive !== currentValues.rewardComprehensive}
                        >
                            {({ getFieldValue }) => {
                                const Inputh = getFieldValue('rewardComprehensive') === 'COMPOSITE' ? (
                                    <>
                                        <FormItem className={`${styles.flexCurt}`}>
                                            <FormItem
                                                name="rewardRealVoice"
                                                label="用户好评大于等于"
                                                colon={false}
                                                rules={[
                                                    { required: false, message: '请输入', },
                                                    { type: 'number', min: 1, max: 99, },
                                                ]}>
                                                <InputNumber
                                                    style={{ width: 110, marginRight: '7px' }}
                                                    keyboard={true}
                                                    placeholder='请输入(次)'
                                                    precision={0}
                                                />
                                            </FormItem>
                                            <span className={styles.curtNote}>次<b>系统默认好评不计于内</b></span>
                                        </FormItem>
                                        <h6 className={styles.curtFooter}>当前只输入一项，其它项不输时，只要达到当前输入的条件即触发，全部输入时，则同时需满足所有条件才会触发</h6>
                                    </>
                                ) : (
                                        <>
                                            <FormItem className={`${styles.flexCurt}`}>
                                                <FormItem
                                                    name="rewardAmount"
                                                    label="配送金额小于等于"
                                                    colon={false}
                                                    rules={[
                                                        { required: false, message: '请输入', },
                                                        { type: 'number', min: 1, max: 99.99, },
                                                    ]}>
                                                    <InputNumber
                                                        style={{ width: 110, marginRight: '7px' }}
                                                        keyboard={true}
                                                        placeholder='请输入(元)'
                                                        precision={2}
                                                    />
                                                </FormItem>
                                                <span className={styles.curtNote}>元</span>
                                            </FormItem>
                                            <FormItem style={{ margin: '10px 0 0 98px' }} className={`${styles.flexCurt}`}>
                                                <FormItem
                                                    name="rewardAmountEvery"
                                                    label="每"
                                                    colon={false}
                                                    rules={[
                                                        { required: false, message: '请输入', },
                                                        { type: 'number', min: 1, max: 99, },
                                                    ]}>
                                                    <InputNumber
                                                        style={{ width: 110, marginRight: '7px' }}
                                                        keyboard={true}
                                                        placeholder='请输入(单)'
                                                        precision={0}
                                                    />
                                                </FormItem>
                                                <span className={styles.curtNote}>单奖励1单<b>不输入则表示所有小于的订单</b></span>
                                            </FormItem>
                                        </>
                                    );
                                return Inputh;
                            }}
                        </FormItem>
                    </Col>
                </Row>
            </div >
        );

    }
}

Reward.propTypes = {
    form: PropTypes.object.isRequired, // 校验
    data: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // 弹框入参
    details: PropTypes.object,
};

const mapStateToProps = (state) => {
    return {

    };
};

export default connect(mapStateToProps, model.actions)(Reward);